import { QuoteBindingRequestParams, QuoteBindingPostResponse } from '@lio/api-types';
import { TQuoteApiResponse } from '@models/quotes';
import { QuoteBinding } from '@models/quoteBinding';
import { getMultiPolicyQuoteIds } from '@services/quotes/helpers';
import { quoteQueryKey } from '@services/quotes/keys';
import { quoteBindingQueryKey } from '@services/quotes/quoteBinding/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateQuoteBinding = () => {
  const client = useClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async ({ quoteId, ...requestBody }: QuoteBindingRequestParams) => {
      const data = await client
        .post(`quote/${quoteId}/binding`, {
          json: requestBody,
          timeout: 30000,
        })
        .json<QuoteBindingPostResponse>();
      return data;
    },
    onSuccess: (data: any, variables) => {
      data?.items?.forEach((quote: QuoteBinding) => {
        queryClient.invalidateQueries({
          queryKey: quoteBindingQueryKey.get(quote.quoteId),
        });
      });

      const cachedQuote = queryClient.getQueryData<TQuoteApiResponse>(quoteQueryKey.get(variables.quoteId));
      const relatedQuoteIds = new Set([variables.quoteId, ...getMultiPolicyQuoteIds(cachedQuote)]);

      relatedQuoteIds.forEach((quoteId) => {
        queryClient.invalidateQueries({
          queryKey: quoteQueryKey.get(quoteId),
        });
      });
    },
  });
  return mutation;
};
